<template>
<CDataTable
    :items="$dataTableFieldsMaker(Object.values(items))"
    :fields="fields"
    border
    :loading="loading"
>
    <template #name="{item}">
        <td v-if="item.label" class="small">{{ item.label }}</td>
        <td v-else class="small">{{ item.name }}</td>
    </template>

    <template #value="{item}">
        <td v-if="item.type">
            <span v-if="item.type === 'copy'" class="cursor-pointer" v-clipboard:copy="item.value" v-clipboard:success="onCopy">
                <FaIcon icon="copy" />
            </span>

            <span v-if="item.type === 'datetime'" class="d-inline-block ltr">
                {{ item.value ? $moment(item.value).format('jYYYY/jMM/jDD HH:MM:SS') : '---' }}
            </span>

            <span v-if="item.type === 'image'" class="py-0 align-middle">
                <img width="50" :src="item.value" />
            </span>

            <span v-if="item.type === 'callback'">
                {{ item.callback(item.value) }}
            </span>

            <span v-if="item.type === 'raw'">
                <RawContent :content="item.value" />
            </span>

            <span v-if="item.type === 'link'">
                <a v-if="item.value" :href="item.value" :target="item.target || '_blank'">{{ item.anchor_text }}</a>
                <span v-else>---</span>
            </span>

            <span v-if="item.type === 'currency'" class="d-inline-block ltr">
                <span class="d-inline-block">{{ $t('rial') }}</span> {{ $numberWithCommas(item.value) }}
            </span>
        </td>
        <td v-else>{{ item.value || '---' }}</td>
    </template>
</CDataTable>
</template>

<script>
export default {
    name: 'DetailsTable',

    props: {
        item: [Object, Boolean],
        keywords: Array,
    },

    computed: {
        items() {
            if(this.loading) {
                return []
            }

            return this.keywords.map(keyword => {
                if (typeof keyword === 'object') {
                    return {
                        ...keyword,
                        name: keyword.name,
                        type: keyword.type,
                        value: this.item[keyword.name],
                    }
                }

                return {
                    name: keyword,
                    value: this.item[keyword],
                }
            })
        },
        fields() {
            return [
                {
                    key: 'name',
                    label: this.$t('attributes.name'),
                    _style: 'width: 30%'
                },
                {
                    key: 'value',
                    label: this.$t('attributes.value')
                }
            ]
        },
        loading() {
            return !(this.item && Object.keys(this.item).length > 0)
        },
    },
    methods: {
        onCopy(e) {
            e.trigger.classList.add('copied')

            setTimeout(function() {
                e.trigger.classList.remove('copied')
            }, 1000)
        },
    }
}
</script>

<style scoped>
.copied svg {
    color: #AB007E !important;
    transition: all .1s;
}
</style>